module.exports = __webpack_public_path__ + "media/img/report_home-e664972b.svg";